module.exports = __webpack_public_path__ + "static/img/product_banner_14_zh.2dbe98d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_14_zh.png
// module id = fKjQ
// module chunks = 34